module.exports = __webpack_public_path__ + "img/ico_picano.af1c60c4.svg";